import { Building2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useI18n } from "../../context/I18nContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

// Selector global de empresa (G-004 / 2.3). Solo se muestra cuando el usuario
// tiene acceso a 2 o más empresas. Cambia el contexto empresarial activo desde
// cualquier pantalla sin volver al Home.
export default function TenantSwitcher() {
  const { companies, activeCompany, switchCompany } = useAuth();
  const { lang } = useI18n();
  const es = lang === "es";

  if (!companies || companies.length < 2) return null;

  const current = activeCompany || companies.find((c) => c.is_default)?.id || companies[0]?.id;
  const isImpersonating = !companies.find((c) => c.id === current)?.is_default;

  return (
    <div data-testid="company-switcher" className="hidden sm:block" title={es ? "Empresa activa" : "Active company"}>
      <Select value={current} onValueChange={switchCompany}>
        <SelectTrigger data-testid="company-switcher-select"
          className={`h-8 rounded-full text-xs gap-1.5 pl-2.5 pr-2 max-w-[200px] ${isImpersonating ? "border-gold bg-gold/10 text-gold" : "border-navy/15"}`}>
          <Building2 className={`w-3.5 h-3.5 shrink-0 ${isImpersonating ? "text-gold" : "text-navy/40"}`} />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {companies.map((c) => (
            <SelectItem key={c.id} value={c.id} data-testid={`company-option-${c.id}`}>
              {c.name}{c.is_default ? (es ? " · principal" : " · default") : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
